export enum ApplicantReceivingMode {
  EMAIL = 'email',
  EXTERNAL = 'external',
}

export enum CompanyType {
  PUBLIC = 'public_company',
  PRIVATE = 'private_company'
}
